export default "__VITE_PUBLIC_ASSET__f3f85b31__"